{
  "common": {
    "on": "Bật",
    "off": "Tắt",
    "yes": "Có",
    "no": "Không",
    "cancel": "Huỷ",
    "networkError": "Lỗi mạng — kiểm tra kết nối"
  },
  "platform": {
    "shopify": "Shopify",
    "etsy": "Etsy",
    "woocommerce": "WooCommerce",
    "tiktok": "TikTok",
    "amazon": "Amazon",
    "printway": "Printway",
    "manual": "Thủ công",
    "unknown": "Không rõ"
  },
  "statusLabels": {
    "Active": "Đang hoạt động",
    "Inactive": "Ngừng hoạt động",
    "Frozen": "Đóng băng",
    "Disconnected": "Mất kết nối"
  },
  "syncHealthLabels": {
    "healthy": "Tốt",
    "warning": "Cảnh báo",
    "critical": "Nghiêm trọng",
    "unknown": "Không rõ"
  },
  "syncJobStatusLabels": {
    "succeeded": "Thành công",
    "failed": "Thất bại",
    "running": "Đang chạy",
    "queued": "Trong hàng đợi",
    "dlq": "DLQ"
  },
  "autoPush": {
    "immediate": "Ngay lập tức",
    "30m": "30 phút",
    "1h": "1 giờ",
    "4h": "4 giờ",
    "manual": "Thủ công"
  },
  "list": {
    "title": "Cửa hàng",
    "subtitle": "Quản lý kết nối store, theo dõi Sync Health và xử lý DLQ. Frozen store sẽ giữ đơn hàng và dừng sync cho đến khi được kích hoạt lại.",
    "openQueueMonitor": "Mở Queue Monitor →",
    "openBullBoardTitle": "Mở Bull Board",
    "empty": "Không có store nào khớp bộ lọc.",
    "tabsAria": "Bộ lọc tab cửa hàng",
    "tabs": {
      "all": "Tất cả",
      "active": "Đang hoạt động",
      "inactive": "Ngừng hoạt động",
      "frozen": "Đóng băng",
      "disconnected": "Mất kết nối"
    },
    "columns": {
      "name": "Tên",
      "platform": "Nền tảng",
      "merchant": "Merchant",
      "status": "Trạng thái",
      "syncHealth": "Tình trạng",
      "lastSync": "Sync gần nhất",
      "lastSyncStatus": "Trạng thái sync",
      "syncErrors24h": "Lỗi 24h",
      "products": "Sản phẩm",
      "orders": "Đơn hàng",
      "webhooks": "Webhook",
      "autoTracking": "Tự động tracking",
      "autoPush": "Tự động đẩy",
      "tokenExpiry": "Token hết hạn",
      "created": "Ngày tạo"
    },
    "filters": {
      "search": {
        "label": "Tìm kiếm",
        "placeholder": "Tên miền shop, merchant…"
      },
      "platform": {
        "label": "Nền tảng"
      },
      "syncHealth": {
        "label": "Tình trạng sync"
      }
    },
    "actions": {
      "openStoreAria": "Mở cửa hàng {{name}}",
      "openStoreTitle": "Mở chi tiết cửa hàng"
    },
    "legend": {
      "title": "Chú thích màu hàng:",
      "aria": "Chú thích màu hàng",
      "criticalHealth": "Tình trạng nghiêm trọng",
      "frozen": "Đóng băng",
      "disconnected": "Mất kết nối"
    }
  },
  "kpi": {
    "totalStores": {
      "label": "Tổng số cửa hàng",
      "sub": "trên tất cả merchant"
    },
    "active": {
      "label": "Đang hoạt động",
      "sub": "đã kết nối & đang sync"
    },
    "attention": {
      "label": "Cần chú ý",
      "sub": "đóng băng hoặc mất kết nối"
    }
  },
  "detail": {
    "missingId": "Thiếu mã store trên URL.",
    "loading": "Đang tải chi tiết store…",
    "back": "Quay lại Cửa hàng",
    "statusTitle": "Trạng thái kết nối (OAuth + trạng thái đóng băng)",
    "platformLabel": "Nền tảng:",
    "merchantLabel": "Merchant:",
    "tabsAria": "Tab chi tiết cửa hàng",
    "tabs": {
      "info": "Thông tin",
      "config": "Cấu hình sync",
      "orders": "Đơn hàng",
      "products": "Sản phẩm",
      "history": "Lịch sử sync",
      "health": "Tình trạng sync",
      "webhook": "Webhook"
    },
    "actions": {
      "forceSync": "Sync thủ công",
      "unfreeze": "Bỏ đóng băng",
      "unfreezing": "Đang bỏ đóng băng…",
      "freeze": "Đóng băng",
      "disconnect": "Ngắt kết nối"
    },
    "info": {
      "storeInfoTitle": "Thông tin cửa hàng",
      "name": "Tên",
      "platform": "Nền tảng",
      "shopDomain": "Tên miền shop",
      "platformStoreId": "Mã store trên nền tảng",
      "status": "Trạng thái",
      "connectedAt": "Kết nối lúc",
      "frozenReason": "Lý do đóng băng",
      "merchantInvoicesTitle": "Merchant + Hoá đơn (08.2)",
      "merchant": "Merchant",
      "merchantId": "Mã merchant",
      "tokenExpiry": "Token hết hạn",
      "invoiceCrossLink": "Liên kết hoá đơn sang Phase 8.2 sẽ có ở ADMIN-22.",
      "adminActionsLogTitle": "Nhật ký thao tác admin",
      "adminActionsLogBody": "Nhật ký kiểm toán ngắt kết nối / đóng băng / bỏ đóng băng / sync thủ công sẽ có qua task-45 (BE impersonation ghi các dòng audit).",
      "lastErrorFromSync": "Lỗi gần nhất khi sync:"
    },
    "config": {
      "title": "Cấu hình sync",
      "productSync": "Sync sản phẩm",
      "orderSync": "Sync đơn hàng",
      "mappingAi": "Mapping AI",
      "autoPushInventory": "Tự động đẩy tồn kho",
      "autoPushOrderConfig": "Cấu hình tự động đẩy đơn"
    },
    "history": {
      "dlqBanner_one": "Lỗi cũ hơn {{count}} ngày sẽ tự động bị xoá.",
      "dlqBanner_other": "Lỗi cũ hơn {{count}} ngày sẽ tự động bị xoá.",
      "empty": "Chưa có sync nào.",
      "columns": {
        "queue": "Hàng đợi",
        "status": "Trạng thái",
        "started": "Bắt đầu",
        "finished": "Kết thúc",
        "error": "Lỗi"
      }
    },
    "webhook": {
      "title": "Đăng ký Webhook",
      "secretPresent": "Có secret",
      "endpointToken": "Endpoint token",
      "scopes": "Scopes",
      "revealSecret": "Hiện secret",
      "remaskingIn": "Che lại sau {{seconds}}s…",
      "revealPrompt": "Xác nhận mật khẩu admin để xem webhook secret. Secret sẽ được che lại sau 30s.",
      "autoRemaskNote": "secret được che lại tự động sau 30 giây."
    },
    "toast": {
      "unfrozenTitle": "Đã bỏ đóng băng store",
      "unfrozenDesc": "Trạng thái kết nối đã khôi phục về Đang hoạt động.",
      "unfreezeFailTitle": "Bỏ đóng băng thất bại",
      "frozenTitle": "Đã đóng băng store",
      "frozenDesc": "{{name}} hiện đang Đóng băng.",
      "syncQueuedTitle": "Đã thêm sync vào hàng đợi",
      "syncQueuedDesc": "Job {{jobId}} đã được lên lịch.",
      "disconnectedTitle": "Đã ngắt kết nối store",
      "disconnectedDesc": "{{name}} đã được ngắt kết nối."
    }
  },
  "syncHealth": {
    "title": "Tình trạng sync",
    "subtitle": "Tỷ lệ lỗi 24h, sparkline 7 ngày và lịch sử lỗi gần nhất.",
    "errorRate24h": "Tỷ lệ lỗi 24h:",
    "dlqBanner_one": "Lỗi cũ hơn {{count}} ngày sẽ tự động bị xoá (DLQ TTL retention do Phase 5 quản lý).",
    "dlqBanner_other": "Lỗi cũ hơn {{count}} ngày sẽ tự động bị xoá (DLQ TTL retention do Phase 5 quản lý).",
    "sparklineTitle": "Sparkline (7 ngày)",
    "sparklineAria": "Sparkline tỷ lệ lỗi 7 ngày",
    "webhookTitle": "Giao webhook (24h)",
    "webhookAria": "Thống kê giao webhook (24h gần nhất)",
    "received": "Đã nhận:",
    "processed": "Đã xử lý:",
    "failed": "Thất bại:",
    "recentErrorsTitle": "Lỗi gần nhất (10 dòng)",
    "recentErrorsAria": "10 lỗi sync gần nhất",
    "noRecentErrors": "Không có lỗi gần đây.",
    "loading": "Đang tải sync health…",
    "columns": {
      "queue": "Hàng đợi",
      "status": "Trạng thái",
      "class": "Loại",
      "started": "Bắt đầu",
      "retry": "Thử lại",
      "error": "Lỗi"
    }
  },
  "orders": {
    "title": "Đơn hàng từ store",
    "showingLatest_one": "Hiển thị {{count}} đơn mới nhất theo created_at.",
    "showingLatest_other": "Hiển thị {{count}} đơn mới nhất theo created_at.",
    "totalAvailable": "Tổng số đơn hiện có:",
    "viewAll": "Xem toàn bộ trong Admin Orders →",
    "loading": "Đang tải đơn hàng…",
    "empty": "Chưa có đơn hàng nào từ store này.",
    "columns": {
      "orderNumber": "Mã đơn",
      "status": "Trạng thái",
      "payment": "Thanh toán",
      "items": "Số lượng",
      "total": "Tổng tiền",
      "received": "Nhận lúc"
    }
  },
  "products": {
    "title": "Sản phẩm trên store",
    "subtitle": "Sản phẩm Printway gắn vào store thông qua SKU mapping. Xem chi tiết tại Mapping Center.",
    "openMapping": "Mở Mapping Center →",
    "pendingTitle": "Mapping đang chờ (mở)",
    "pendingSubtitle": "SKU lạ từ store chưa được map sang Printway catalog. Tổng:",
    "loading": "Đang tải mapping…",
    "empty": "Không có mapping pending nào — mọi SKU đã được resolve.",
    "columns": {
      "externalSku": "SKU ngoài",
      "title": "Tiêu đề",
      "status": "Trạng thái",
      "created": "Ngày tạo"
    },
    "notePrefix": "Danh sách \"Mapped SKUs\" (đã resolve) chưa có endpoint riêng — sẽ bổ sung khi BE expose",
    "noteSuffix": "(Phase 8.1 amendment đang chờ)."
  },
  "modals": {
    "disconnect": {
      "title": "Ngắt kết nối store",
      "descPrefix": "Ngắt kết nối store",
      "descSuffix": ". OAuth refresh token sẽ bị xoá; merchant sẽ phải kết nối lại từ đầu. Webhooks sẽ ngừng nhận event mới. Đây là hành động phá huỷ.",
      "confirmTypePrefix": "Gõ",
      "confirmTypeSuffix": "để xác nhận",
      "noteLabel": "Ghi chú (tuỳ chọn)",
      "notePlaceholder": "Lý do ngắt kết nối (audit log)",
      "submit": "Ngắt kết nối store",
      "submitting": "Đang ngắt kết nối…"
    },
    "forceSync": {
      "title": "Sync thủ công",
      "descWithName": "Buộc đồng bộ lại \"{{name}}\". Hệ thống sẽ thêm một sync_job vào hàng đợi BullMQ và worker Phase 5 sẽ xử lý ngay khi rảnh.",
      "descNoName": "Buộc đồng bộ lại. Hệ thống sẽ thêm một sync_job vào hàng đợi BullMQ và worker Phase 5 sẽ xử lý ngay khi rảnh.",
      "queueLabel": "Loại queue",
      "queues": {
        "polling": "Polling — lấy lại đơn hàng + sản phẩm",
        "orderImport": "Order Import — kéo lại đơn gần đây",
        "productSync": "Product Sync — đẩy cập nhật catalog"
      },
      "submit": "Sync thủ công",
      "submitting": "Đang lên lịch…"
    },
    "freeze": {
      "title": "Đóng băng store",
      "descWithName": "Đóng băng store \"{{name}}\". Sync sẽ dừng và đơn hàng tiếp theo sẽ được giữ lại. Merchant sẽ được thông báo. Bạn vẫn có thể bỏ đóng băng (unfreeze) sau.",
      "descNoName": "Đóng băng store. Sync sẽ dừng và đơn hàng tiếp theo sẽ được giữ lại. Merchant sẽ được thông báo. Bạn vẫn có thể bỏ đóng băng (unfreeze) sau.",
      "reasonLabel": "Lý do",
      "reasonPlaceholder": "Ví dụ: vi phạm chính sách / nghi ngờ gian lận / merchant yêu cầu tạm dừng",
      "reasonCounter": "{{len}}/{{max}} ký tự — tối thiểu {{min}}.",
      "noteLabel": "Ghi chú (tuỳ chọn)",
      "notePlaceholder": "Ghi chú nội bộ — không hiển thị cho merchant",
      "submit": "Đóng băng store",
      "submitting": "Đang đóng băng…"
    }
  }
}
